import React from "react";
import { Section } from "./primitives";
import { roadmap as R } from "../mock/inferraData";

const TONE = {
  live: { c: "#7a5210", label: "#9c6a16" },
  early: { c: "var(--green)", label: "var(--green)" },
  next: { c: "#3f4a53", label: "#3f4a53" },
  later: { c: "var(--muted)", label: "var(--muted)" },
  research: { c: "var(--muted)", label: "var(--muted)" },
};

export default function Roadmap() {
  return (
    <Section id="roadmap" bg="var(--cream)" pt={150} pb={150}>
      <h2 className="font-type reveal" style={{ margin: "0 0 48px", fontSize: "clamp(32px,4.4vw,58px)", fontWeight: 700, lineHeight: 1.03, letterSpacing: "-1.4px" }}>
        {R.heading}
      </h2>
      <div className="rm-grid" style={{ display: "grid", gridTemplateColumns: "repeat(5, minmax(0,1fr))", gap: 16 }}>
        {R.cols.map((col, i) => {
          const t = TONE[col.tone];
          const highlight = col.tone === "live";
          return (
            <div
              key={col.label}
              className={`card-lift reveal ${i ? "d" + i : ""}`}
              style={{
                padding: 24,
                borderRadius: 14,
                background: highlight ? "#f6efdc" : "#fbfaf6",
                border: `1px solid ${highlight ? "#e6d5a8" : "var(--line)"}`,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                minHeight: 180,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 700, color: t.label }}>{col.label}</span>
              <div style={{ display: "flex", flexDirection: "column", gap: 10, fontSize: 18 }} className="font-type">
                {col.items.map((it) => (
                  <span key={it}>{it}</span>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <style>{`
        @media (max-width: 900px) { .rm-grid { grid-template-columns: repeat(2, minmax(0,1fr)); } }
        @media (max-width: 520px) { .rm-grid { grid-template-columns: 1fr; } }
      `}</style>
    </Section>
  );
}
